// サイトが読む入口。**このファイルは合成するだけ**で、値を持たない。
//
//   album.generated.ts … releases/<slug>/*.md からの生成物（写像）。手で編集しない
//   album.site.ts      … サイト固有のコピー（紹介文・ジャンル・タイムライン等）。原本
//
// 文言を直すときは原本の md を直して `./scripts/build-site-data.py` を回す。
// ズレの確認は `./scripts/build-site-data.py --check`。

import {
  generatedAlbumData,
  lyricsSections,
  linerNotesEn,
  linerNotesJa,
} from './album.generated';
import { siteAlbumData } from './album.site';

export const albumData = {
  ...siteAlbumData,
  ...generatedAlbumData, // 原本(md)由来が勝つ。同名キーはこちらで上書きされる
  credit: {
    ...siteAlbumData.credit,
    ...generatedAlbumData.credit,
  },
};

export { lyricsSections, linerNotesEn, linerNotesJa };
